<div class="titled-card-container">
  <div class="flex justify-between items-center mb-4" *transloco="let t">
    <div class="grow"></div>
    <div class="flex gap-3">
      <p-button
        label="{{ 'user.management.sendInvitations' | transloco }}"
        icon="pi pi-envelope"
        styleClass="h-10"
        [severity]="'secondary'"
        (onClick)="onSendInvitations()"
        [disabled]="!hasSelectedUsers || loading()"
        data-testid="send-invitations-button"
      ></p-button>
      <p-button
        [label]="t('user.management.addUser')"
        styleClass="h-10"
        icon="pi pi-plus"
        data-testid="add-user-button"
        (onClick)="openNewUserDialog()"
      ></p-button>
    </div>
  </div>
  <p-card data-testid="user-management-card">
    <ng-container *transloco="let t">
      <p-table
        #dt
        [value]="users()"
        [rows]="10"
        [paginator]="true"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="{{ 'common.table.currentPageReportTemplate' | transloco }}"
        [globalFilterFields]="globalFilterFields"
        [tableStyle]="{'min-width': '50rem'}"
        [loading]="loading()"
        dataKey="userId"
        [(selection)]="selectedUsers"
        selectionMode="multiple"
        data-testid="user-management-table"
      >
        <ng-template #caption>
          <div class="flex justify-end">
            <app-global-search (searchValue)="dt.filterGlobal($event, 'contains')" />
          </div>
        </ng-template>
        <ng-template #header>
          <tr>
            <th style="width: 4rem" scope="col">
              <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
            </th>
            <th pSortableColumn="lastName" data-testid="user-management-name-header" scope="col">
              {{ t('common.name') }}
              <p-sortIcon field="lastName"></p-sortIcon>
            </th>
            <th pSortableColumn="email" data-testid="user-management-email-header" scope="col">
              {{ t('common.email') }}
              <p-sortIcon field="email"></p-sortIcon>
            </th>
            <th pSortableColumn="status" data-testid="user-management-status-header" scope="col">
              {{ t('common.status') }}
              <p-sortIcon field="status"></p-sortIcon>
            </th>
            <th pSortableColumn="roles" data-testid="user-management-roles-header" scope="col">
              {{ t('common.role') }}
              <p-sortIcon field="roles"></p-sortIcon>
            </th>
            <th style="width: 5rem" scope="col"></th>
          </tr>
        </ng-template>
        <ng-template #body let-user>
          <tr [attr.data-user-id]="user.userId">
            <td data-testid="user-management-checkbox-cell">
              <p-tableCheckbox
                [value]="user"
                [disabled]="!isInvitable(user)"
                data-testid="user-selection-checkbox"
              ></p-tableCheckbox>
            </td>
            <td data-testid="user-management-name-cell">{{ getUserName(user) }}</td>
            <td data-testid="user-management-email-cell">{{ user.email }}</td>
            <td data-testid="user-management-status-cell">
              <span
                class="px-2 py-1 text-xs font-medium rounded-md"
                [ngClass]="getStatusClass(user.status)"
              >
                {{ getStatusLabel(user.status) }}
              </span>
            </td>
            <td data-testid="user-management-roles-cell">{{ getUserRoles(user) }}</td>
            <td>
              <p-button
                icon="pi pi-ellipsis-v"
                class="p-button-text p-button-rounded p-button-plain"
                (onClick)="onRowMenuClick($event, user)"
                severity="secondary"
                data-testid="user-management-actions-button"
              ></p-button>
            </td>
          </tr>
        </ng-template>
        <ng-template #emptymessage>
          <tr>
            <td colspan="7">{{ t('common.noUsers') }}</td>
          </tr>
        </ng-template>
      </p-table>
      <p-menu #rowMenu popup="true"></p-menu>
    </ng-container>
  </p-card>
</div>

<app-add-edit-user-dialog
  [display]="showAddUserDialog()"
  [preselectedRoles]="preselectedRoles()"
  [preselectedAccessiblePages]="preselectedAccessiblePages()"
  (displayChange)="showAddUserDialog.set($event)"
  (save)="handleAddUser($event)"
></app-add-edit-user-dialog>

<app-add-edit-user-dialog
  [display]="showEditUserDialog()"
  [userToEdit]="selectedUser()"
  (displayChange)="showEditUserDialog.set($event)"
  (save)="handleEditUser($event)"
  [isEditMode]="true"
></app-add-edit-user-dialog>
